import { Suspense, type FC } from 'react';
import { LoadingComponent } from '../../components/global/LoadingComponent.tsx';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';
import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient.ts';

import { type PdpRespZoomModalWrapperProps } from './PdpRespZoomModalTypes.ts';

const PdpRespZoomModalLazy = dibsLazyClient(
    () =>
        import(
            /* webpackChunkName: "PdpRespZoomModalWrapper" */
            './PdpRespZoomModalWrapper.tsx'
        )
);

export const PdpRespZoomModalLoader: FC<PdpRespZoomModalWrapperProps> = props => {
    if (!props.isOpen) {
        return null;
    }
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={<LoadingComponent />}>
                <PdpRespZoomModalLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
};
